var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69507 16.9686H4.00024C2.72435 16.9686 1.68912 15.9295 1.68912 14.6575V3.34253C1.68912 2.06664 2.72817 1.03141 4.00024 1.03141H8.77147C9.05797 1.03141 9.28717 0.802207 9.28717 0.515705C9.28717 0.229202 9.05797 0 8.77147 0H4.00024C2.15517 0 0.657715 1.50127 0.657715 3.34253V14.6575C0.657715 16.5025 2.15899 18 4.00024 18H8.69507C8.98157 18 9.21077 17.7708 9.21077 17.4843C9.21077 17.1978 8.97775 16.9686 8.69507 16.9686Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.191 8.6372L13.9134 5.35961C13.711 5.15715 13.3863 5.15715 13.1838 5.35961C12.9813 5.56207 12.9813 5.88678 13.1838 6.08924L15.5828 8.48822H5.11971C4.83321 8.48822 4.604 8.71742 4.604 9.00393C4.604 9.29043 4.83321 9.51963 5.11971 9.51963H15.5828L13.1838 11.9186C12.9813 12.1211 12.9813 12.4458 13.1838 12.6482C13.2831 12.7476 13.4168 12.801 13.5467 12.801C13.6766 12.801 13.8103 12.7514 13.9096 12.6482L17.1872 9.37065C17.3935 9.16437 17.3935 8.83585 17.191 8.6372Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.5a7e3fd8.svg";
export { ForwardRef as ReactComponent };